// JS
require('jquery');
import "bootstrap/dist/js/bootstrap";
import 'bootstrap-fileinput/js/fileinput';
import 'bootstrap-fileinput/js/locales/ja';
import '@nathanvda/cocoon';

//
// ファイル選択フィールドをBootstrap風にする
//
$(document).on('turbolinks:load', () => {
  $('input[type="file"].custom_fileinput').fileinput({
    showUpload: false,
    showBrowse: false,
    showRemove: false,
    showCaption: false,
    showPreview: true,
    allowedPreviewMimeTypes: false,
    previewFileType: null,
    language: 'ja',
    allowedFileExtensions: ['gif', 'png', 'jpg', 'jpeg'],
    browseOnZoneClick: true,
    fileActionSettings: {
      showZoom: false,
    },
    dropZoneTitle: 'ここにファイルをドラッグ & ドロップ',
    dropZoneClickTitle: '<br/>（もしくはクリックしてファイルを選択）',
    msgProcessing: 'ファイルを選択中',
    msgPlaceholder: '',
    initialPreviewShowDelete: false,
  })
})

$(document).on("turbolinks:load", function() {
  // 在 Tab 切换时设置隐藏表单项目的值
  $(".nav-tabs li a").on("click", function() {
    var tabId = $(this).attr("href"); // 获取当前 Tab 的 ID
    var value = $(this).data("hidden-value"); // 从 data 属性中获取需要设置的值
    // 设置隐藏表单项目的值
    $("#trademark-category").val(value);
  });
});

let allTmClassesDivisions = {}
const get_tm_classes_and_divisions = ()=>{
  return $.ajax({
    url: '/trademarks/get_tm_classes_and_divisions',
    type: 'GET',
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    // data: {
    //   tmClassId: tmClassId,
    //   selectedTmDivisionIds: selectedTmDivisionList.map(l => l['id'])
    // },
    success: function(res) {
      // console.log(`success: ${JSON.stringify(res)}`)
      allTmClassesDivisions = res
      // console.log(allTmDivisions)
      // // 生成されたtmDivisionチェックボックスにイベントを設定する
      // const tmDivisionInTmClassElement = document.querySelector(`.tm_division-in-tm_class_${tmClassId}`)
      // if (tmDivisionInTmClassElement) add_event_to_tm_division_checkbox(tmClassId)
    },
    error: function(res) {
      console.log(`error: ${JSON.stringify(res)}`)
    }
  });
}
get_tm_classes_and_divisions()

// 出願目安金額 + 追加費用
const calcTotalCost = (selectedCount,additionalTotalCount,needResearch) => {
  if(selectedCount == 0) return 0

  // 調査費用: 20,000円
  const characterResearchCost = 20000 * selectedCount * (needResearch?1:0)

  // 出願費用（基礎）: 40,000円
  const basicApplicationCost = 40000 * selectedCount

  // 実費(官費等): 6,000円
  const actualApplicationCost = 6000 * selectedCount

  // 追加費用(1商標1区分あたり、指定商品が11以上だったら11個目から1個ごとに640円)
  const additionalCost = 640 * additionalTotalCount

  // 小計(消費税以外)
  const totalCostWithoutTax = characterResearchCost + basicApplicationCost + actualApplicationCost + additionalCost

  // 消費税(10%):
  const consumptionTax = totalCostWithoutTax * 0.1

  // 小計(消費税込み)
  const totalCostIncludedTax = totalCostWithoutTax + consumptionTax

  return totalCostIncludedTax
};

/**
 * 追加費用のdivision情報数を計算する
 * @param {Array.<Object>} selectedTmDivisionList division情報が付加された配列
 */
const additionalTmDivision = (selectedTmDivisionList) => {
  let tmClass = {}
  selectedTmDivisionList.forEach((division)=>{
    if (division.category in tmClass){
      tmClass[division.category] = tmClass[division.category] + 1
    }else{
      tmClass[division.category] = 1
    }
  })
  let additionalTotal = 0
  for (let category in tmClass){
    let additionalCount = tmClass[category] -10 > 0 ? tmClass[category] -10 :0
    additionalTotal = additionalTotal + additionalCount
  }
  return additionalTotal
}

/**
 * 区分数/指定商品数と出願目安金額の表示
 * @param {Array.<Object>} selectedTmClassList class情報が付加された配列
 * @param {Array.<Object>} selectedTmDivisionList division情報が付加された配列
 */
const renderCountAndTotal = (selectedTmClassList, selectedTmDivisionList) => {
  let totalCost = 0
  const selectedClassCount = parseInt(selectedTmClassList.length, 10);
  const selectedDivisionCount = parseInt(selectedTmDivisionList.length, 10);

  // 区分数
  const selectedTmClassCountElement = document.querySelector('#selected_unique_tm_class_count')
  if (selectedTmClassCountElement) selectedTmClassCountElement.innerText = selectedClassCount

  // 指定商品数
  const selectedTmDivisionCountElement = document.querySelector('#selected_tm_division_count')
  if (selectedTmDivisionCountElement) selectedTmDivisionCountElement.innerText = selectedDivisionCount

  // 調査希望
  const needResearch = $("#need_research").is(":checked");

  // 出願目安金額 + 追加費用
  let additionalTotalCount = additionalTmDivision(selectedTmDivisionList)
  totalCost = calcTotalCost(selectedClassCount,additionalTotalCount,needResearch)
  $("#trademark_total_cost").attr("data-trademark-total-cost", totalCost);
  const totalCostElement = document.querySelector('#trademark_total_cost')
  if (totalCostElement) totalCostElement.innerText = totalCost.toLocaleString();
}

/**
 * 指定商品の情報追加
 * @param {Element} classElement 追加するべき指定商品の上位にあるClass element
 * @param {Object} trademarkClass 追加情報の入ったObject
 */
const addDivisionElement = (classElement, trademarkClass) => {
  // class配下のdivisionのfieldを追加しておく
  classElement.querySelector('.trademark_division_add_fields').click();

  // 追加された最後のdivisionを取得
  const nodes = classElement.querySelectorAll('.nested-fields');
  const divisionElement = nodes[nodes.length- 1];

  // 各情報を追加
  divisionElement.querySelector('.tm-division-name').innerText = trademarkClass.tmDivision.name;
  divisionElement.setAttribute('data-record-division-id', `${trademarkClass.tmDivision.id}`);
  divisionElement.querySelector('.form-tm-division-id').value = trademarkClass.tmDivision.id;
}

/**
 * リストから指定されたIDの要素を削除する
 * @param {Array} list 対象のリスト
 * @param {Integer} targetId 削除するためのid
 */
const removeListById = (list, targetId) => {
  list.some((v, i) => {
    if (v.id == targetId) {
      list.splice(i,1);
      return true;
    }
  });
}

let checkedItem = {};
let selectedTmClassList = []
let selectedTmDivisionList = []
let isAlreadySelectedTmClass = false // 既に選択済みclassか

$(document).on("turbolinks:load", () => {
  // 区分数(重複なし) / 指定商品と目安金額の算出
  const tmClassListElement = $("#selected_unique_tm_class_count").attr("data-selected-unique-tm-class-list")
  const tmDivisionListElement = $("#selected_tm_division_count").attr("data-selected-tm-division-list")
  if (tmClassListElement) selectedTmClassList = JSON.parse(tmClassListElement);
  if (tmDivisionListElement) selectedTmDivisionList = JSON.parse(tmDivisionListElement);
  renderCountAndTotal(selectedTmClassList, selectedTmDivisionList)

  $('#trademark-classes > :not(:has(#trademark-divisions))')
    .on('cocoon:before-insert', (event, insertedItem) => {
      console.debug('#trademark-classes cocoon:before-insert called');
      insertedItem[0].setAttribute('trademark-class', JSON.stringify(checkedItem));

      // 既に同classが選択されていたら新しいfieldは追加せず既存のfieldにdivisonを追加していく
      if (isAlreadySelectedTmClass) {
        event.preventDefault();
        const trademarkClass = JSON.parse(insertedItem[0].getAttribute('trademark-class'));
        const classElement = document.querySelector(`.nested-fields[data-record-class-id="${trademarkClass.tmClass.id}"]:not([style*="display: none"])`);

        // divisionの追加
        addDivisionElement(classElement, trademarkClass)
      }
    })
    .on('cocoon:after-insert', (_, insertedItem) => {
      console.debug('#trademark-classes cocoon:after-insert called');
      const trademarkClass = JSON.parse(insertedItem[0].getAttribute('trademark-class'));

      // JS経由で値が追加された場合に選択されたテキスト情報とform情報を反映
      insertedItem[0].querySelector('.tm-class-category-index').innerText = trademarkClass.tmClass.category_index;
      insertedItem[0].querySelector('.tm-class-name').innerText = trademarkClass.tmClass.name;
      insertedItem[0].setAttribute('data-record-class-id', `${trademarkClass.tmClass.id}`);
      insertedItem[0].querySelector('.form-tm-class-id').value = trademarkClass.tmClass.id;

      // divisionの追加
      addDivisionElement(insertedItem[0], trademarkClass)
    });

  $('#trademark-classes')
    .on('cocoon:after-remove', (e, removed_item) => {
      console.debug('#trademark-divisions cocoon:after-remove called');
      const classElement = document.querySelector(`.nested-fields[data-record-class-id="${checkedItem.tmClass.id}"]:not([style*="display: none"]`);
      if (classElement === null) return

      // 選択したdivisionも削除
      removeListById(selectedTmDivisionList, checkedItem.tmDivision.id)
      renderCountAndTotal(selectedTmClassList, selectedTmDivisionList)

      const divisionElement = classElement.querySelector('.nested-fields:not([style*="display: none"])');
      if (divisionElement !== null) return

      // 全てのdivisionがなくなったらclassもremoveする
      classElement.querySelector('.trademark_class-close').click();

      // 選択したclassも削除
      removeListById(selectedTmClassList, checkedItem.tmClass.id)
      renderCountAndTotal(selectedTmClassList, selectedTmDivisionList)
    });

  document.querySelectorAll('.tm_class-check-input').forEach(tmClassInput => {
    // 区分を選択したときに
    tmClassInput.addEventListener('click', function() {
      const tmClassId = this.value;
      // console.log(`tmClassInput click: ${JSON.stringify(tmClassId)}`)
      clear_tm_division_checkbox()
      const success = get_cache_tm_division(tmClassId)
      if (!success){
        setTimeout(() => {
          get_cache_tm_division(tmClassId)
        }, 2000);
      }
    });
  });
});

// tmClassIdの区分以外のチェックボックスを要素ごと消す(d-noneを付与してもチェックボックス自体が多いと重い)
const clear_tm_division_checkbox = () => {
  document.querySelectorAll('.tm_division-wrapper:not(.d-none)').forEach(division => {
    division.remove()
  });
}

// 指定商品を区分ごとに読み込む(非同期処理)
const get_cache_tm_division = (tmClassId)=>{
  const allTmClasses = allTmClassesDivisions["tm_classes"]
  const allTmDivisions = allTmClassesDivisions["tm_divisions"]
  if (allTmDivisions && allTmDivisions.length > 0){
    const divisions = allTmDivisions.filter(item=>item["tm_class_id"].toString()==tmClassId.toString())
    let htmlText = ''
    for (var division of divisions){
      const tmClass = allTmClasses.find((item)=>{
        return item["id"].toString() == division["tm_class_id"].toString()
      })
      const isSelectTmDivision = selectedTmDivisionList.find((selectedDvision)=>{
        return selectedDvision['id']==division['id']
      })
      const element = `<div class="form-check py-1 tm_division-wrapper tm_division-in-tm_class_${tmClassId}"> \
                    <input type="checkbox" ${isSelectTmDivision? 'checked' : ''} name="tm_division_${division['id']}" id="tm_division_${division['id']}" value="${division['id']}" class="form-check-input tm_division-check-input-in-tm_class_${tmClassId}" data-tm-class='${JSON.stringify(tmClass)}' data-tm-division='${JSON.stringify(division)}'> \
                    <label class="form-check-label" for="tm_division_${division['id']}">${division['name']}</label> \
                </div>`
      htmlText = htmlText + element
    }
    $("#js-tm_divisions").html(htmlText)
    const tmDivisionInTmClassElement = document.querySelector(`.tm_division-in-tm_class_${tmClassId}`)
    if (tmDivisionInTmClassElement) add_event_to_tm_division_checkbox(tmClassId)
    return true
  }else{
    return false
  }
}

const get_tm_division = (tmClassId) => {
  return $.ajax({
    url: '/trademarks/get_tm_divisions',
    type: 'GET',
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    data: {
      tmClassId: tmClassId,
      selectedTmDivisionIds: selectedTmDivisionList.map(l => l['id'])
    },
    success: function(res) {
      // console.log(`success: ${res}`)
      // 生成されたtmDivisionチェックボックスにイベントを設定する
      const tmDivisionInTmClassElement = document.querySelector(`.tm_division-in-tm_class_${tmClassId}`)
      if (tmDivisionInTmClassElement) add_event_to_tm_division_checkbox(tmClassId)
    },
    error: function(res) {
      console.log(`error: ${JSON.stringify(res)}`)
    }
  });
}

// 指定商品のチェックボックスへのイベント設定
const add_event_to_tm_division_checkbox = (tmClassId) => {
  document.querySelectorAll(`.tm_division-check-input-in-tm_class_${tmClassId}`).forEach(tmDivisionInput => {
    // console.log(`tm_division-check-input-in-tm_class: ${JSON.stringify(tmClassId)}`)
    tmDivisionInput.addEventListener('click', function() {
      // 指定商品を選択したときに「選択した候補」に表示
      // console.debug('tmDivisionInput:', this.value, this.checked);
      const tmClass = JSON.parse(this.getAttribute('data-tm-class'))
      const tmDivision = JSON.parse(this.getAttribute('data-tm-division'))
      const item = {
        tmClass: tmClass,
        tmDivision: tmDivision,
      };
      checkedItem = { ...item };

      if (this.checked) {
        // 選択が追加されたときに「選択した候補」に追加
        // 既にclassが選択していたら追加しない(classは重複しない)
        isAlreadySelectedTmClass = selectedTmClassList.some((v, _) => v.id == item.tmClass.id )
        if (!isAlreadySelectedTmClass) selectedTmClassList = selectedTmClassList.concat(tmClass)
        selectedTmDivisionList = selectedTmDivisionList.concat(tmDivision)

        // class/divisionを追加(上記 cocoon:before-insert callbackを起動)
        document.querySelector('.trademark_class_add_fields').click();
      } else {
        // 選択が解除されたときに「選択した候補」から削除
        // divisionを削除(上記 cocoon:after-remove callbackを起動)
        document.querySelector(`.nested-fields[data-record-division-id="${item.tmDivision.id}"]`).querySelector('.remove_fields').click();
      }

      renderCountAndTotal(selectedTmClassList, selectedTmDivisionList)
    });
  });
}

$(document).on("turbolinks:load", function() {
  // 在 Tab 切换时设置隐藏表单项目的值
  $("#need_research").on("change", function(event) {
    renderCountAndTotal(selectedTmClassList, selectedTmDivisionList)
  });
});


